import { render, staticRenderFns } from "./ImageElementEdit.vue?vue&type=template&id=3083cc09&"
import script from "./ImageElementEdit.vue?vue&type=script&lang=js&"
export * from "./ImageElementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports